const number = (value) => {
  // var animate = true;
  if ((!value && value != 0) || (value && isNaN(value))) return "-";

  let num = parseFloat(value);
  return num.toLocaleString("pt-BR", {
    maximumFractionDigits: 2,
  });
};

const protect = (value) => {
  const check = localStorage.getItem("ActiveProtect");
  if (check) {
    return "*"+value.substring(1,5)+"*****"
  }

  return value
};

const money = (value, currency) => {
  if (!currency) {
    currency = "BRL";

  }

  // const check = localStorage.getItem("ActiveProtect");
  // if (check) {
  //   return "R$ *****"
  // }

  let currencys = [
    {
      value: "BRL",
    },
    {
      value: "USD",
    },
  ];

  let currentCurrency = currencys.find((cur) => {
    return cur.value === currency;
  });

  let lang = 'pt-BR'
  if (currency == 'USD') {
    lang = 'us'
  }

  let formatCurrency = new Intl.NumberFormat(lang, {

    style: "currency",
    currency: currentCurrency.value,
  }).format(value);

  if ((!value && value != 0) || (value && isNaN(value))) {
    return `-`;
  }

  return formatCurrency;
};

const moment = require("moment");

const date = (value, format) => {
  let d = value;

  if (typeof d === "string") {
    d = new Date(d);
  }

  if (d === null || d === undefined) {
    return " - ";
  }

  if (isNaN(d.getTime())) {
    return value;
  }

  if (format === undefined) {
    format = "DD/MM/YYYY - HH:mm:ss";
  }

  return moment(d).format(format);
};

const time = (value) => {
  if (!value && value != 0) return "0 min";

  if (value == 0) return "0 min";

  let result = "";

  let time = parseFloat(value).toFixed(3);
  let hours = Math.floor(time / 60 / 60);
  let minutes = Math.floor(time / 60) % 60;
  let seconds = Math.floor(time - minutes * 60);

  let days = parseInt(hours / 24);
  let weeks = parseInt(days / 7);
  let month = parseInt(weeks / 4);
  let year = parseInt(month / 12);

  if (seconds >= 1) result = `${seconds} segundos `;
  if (minutes >= 1) result = `${minutes} minutos `;
  if (hours == 1) result = `${hours} hora `;
  if (hours > 1) result = `${hours} horas `;
  if (days == 1) result = `${days} dia `;
  if (days > 1) result = `${days} dias `;
  if (weeks >= 1) result = `${weeks} semanas `;
  if (month == 1) result = `${month} mês `;
  if (month > 1) result = `${month} meses `;
  if (year == 1) result = `${year} ano `;
  if (year > 1) result = `${year} anos `;

  return result;
};

export { number, money, date, time, protect };
